import { octopusLogs } from '@octopus-sdk/browser-logs'
import { octopusRum } from '@octopus-sdk/browser-rum'

export enum LogLevel {
  TRACE = 'TRACE',
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  FATAL = 'FATAL',
}

const ENV = process.env.REACT_APP_ENV === 'online' ? 'online' : 'test'

class Octopus {
  private initialized = false

  private logsInstance: typeof octopusLogs

  private rumInstance: typeof octopusRum

  constructor() {
    this.logsInstance = octopusLogs
    this.rumInstance = octopusRum
  }

  init() {
    if (this.initialized) {
      console.warn('[OctopusMonitor] 已经初始化，跳过重复初始化')
      return
    }

    const defaultSite = 'octopus-ingest-cn.zhenguanyu.com'
    const commonConfig = {
      applicationId: '6d634b8c-37b5-41e7-9ea7-63e8b1929594',
      clientToken: 'ac82f64a4fdf460baea9ca322851d543',
      service: 'metis-login-web2',
      env: ENV,
      enable: ['test', 'online'].includes(process.env.REACT_APP_ENV as string),
      site: defaultSite,
      version: process.env.REACT_APP_COMMIT_HASH,
    }

    this.logsInstance.init({ ...commonConfig })

    this.rumInstance.init({
      ...commonConfig,
      trackUserInteractions: true,
      trackResources: true,
      trackViewsManually: true,
      allowedTracingUrls: [
        {
          match(url: string) {
            return /mapi\.feixiangxingqiu\.(biz|com)/.test(url)
          },
          propagators: [
            { type: 'skywalking', skywalkingNamespace: 'default-namespace' },
          ],
        },
      ],
    })

    this.initialized = true
  }

  get logger() { return this.logsInstance.logger }
  get logs() { return this.logsInstance }
  get rum() { return this.rumInstance }

  setUser(user: { id: string, name?: string, email?: string, [key: string]: any }) {
    this.logsInstance.setUser?.(user)
    this.rumInstance.setUser?.(user)
  }

  setGlobalContext(context: Record<string, any>) {
    this.logsInstance.setGlobalContext?.(context)
    this.rumInstance.setGlobalContext?.(context)
  }
}

export const formatLogMessage = (level: LogLevel, type: string, params: Record<string, any>) => `[${level}] [${type}] ${JSON.stringify(params)}`

export const octopus = new Octopus()
